import getBruggerAdminClientAddress from '@Infowijs-eng/component-library/modules/getBruggerAdminClientAddress'
import { isDevelopment, isStaging } from '@Infowijs-eng/component-library/modules'

function resolveHoyAdress(productName : string, permissions = []) {
  if (!productName || typeof productName !== 'string') {
    throw new Error('Please pass a productname slug as string')
  }

  if (isDevelopment && process.env.INFOWIJS_DEV_CLIENT_HOY_WEB) {
    return process.env.INFOWIJS_DEV_CLIENT_HOY_WEB.toLowerCase().replace('[subdomain]', productName)
  }

  const isAdmin = permissions.includes('hoy.users.list')
  const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'

  const client = isAdmin ? 'admin' : 'web'
  const clientUriPart = isStaging ? `${client}.staging` : client

  let uri = `https://${productName}.${clientUriPart}.hoyapp.${tld}`

  if (isAdmin) {
    uri += '/messages/inbox'
  }

  return uri
}

export default function getRedirectUrlForCustomerProduct(
  productType: string,
  productName: string,
  userPermissions: string[] = [],
) {
  switch (productType) {
    case 'hoy':
      return resolveHoyAdress(productName, userPermissions)
    case 'brugger':
      return getBruggerAdminClientAddress(productName)
    case 'schoolwiki': {
      if (isDevelopment && process.env.INFOWIJS_CLIENT_SCHOOLWIKI) {
        return process.env.INFOWIJS_CLIENT_SCHOOLWIKI.toLowerCase().replace('[subdomain]', productName)
      }
      const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'
      const clientUriPart = isStaging ? '.staging' : ''
      return `https://${productName}${clientUriPart}.schoolwiki.${tld}/admin`
    }
    default:
      return null
  }
}
